query RevitBuiltInParameters {
    revitBuiltInParameters {
        id
        key
        name(revitLocale: "ENU") {
            revitLocale
            text
        }
    }
}
